import { managerInstance } from "libs/api";

import { CompanyManager } from "../../managers.types";

export const requestGetManagers = async (
  search?: string
): Promise<CompanyManager[]> => {
  return await managerInstance.get("/delivery-company/managers", {
    params: search ? { search } : undefined
  });
};
